<template>
  <el-col :span="8" class="statistic-graph">
    <el-card class="data" v-loading="loading_campaigns">
      <div class="card-header" slot="header">
        <div class="card-header__title">
          <i class="fas fa-chart-bar"></i>
          <span>CAMPAIGNS</span>
        </div>
        <div class="card-header__total">
          <div>Total: {{ total }}</div>
        </div>
      </div>
      <GChart
        type="ColumnChart"
        :data="campaign_chart"
        :options="CampaignChartSett"
        v-if="campaign_chart.length > 1"
      />
      <div v-else class="no-data"><span>No Data</span></div>
      <div class="card-footer">
        <div class="border"></div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
export default {
  components: {
    GChart
  },

  computed: {
    ...mapState('adminDashboard', ['CampaignChartSett', 'loading_campaigns', 'campaigns']),
    ...mapGetters('adminDashboard', ['campaign_chart']),

    total() {

      let total = 0
      this.campaigns.forEach(item => {
        if(!item.ended) item.ended = 0;
        if(!item.live) item.live = 0;
        total+= item.live + item.ended
      })
      return this.commaNum(total, 0)
    }
  },

  data() {
    return {
    }
  },

  methods: {
    ...mapActions('adminDashboard', ['readCampaigns']),
  }
}
</script>
